export enum ForceDirection {
    English = 1,
    Arabic = 2
  }